import type { TextField } from '@warp-ds/react';
import cn from 'classnames';
import type { ReactElement } from 'react';
import { useBreakpoints } from '../../hooks/useBreakpoints';
import { BasicDatePicker, type RangeSelectionProps, type SingleSelectionProps } from '../basicDatePicker/BasicDatePicker';

import styles from './FrontpageDatePickerWrapper.module.css';

export const FrontpageDatePickerWrapper = ({
    startDate,
    endDate,
    onDateChange,
    className,
    modalFooter,
    upperDateLimit,
    useRange,
    disabledDateRanges,
    useAnchor,
    children,
}: Omit<SingleSelectionProps, 'visibleMonths'> | Omit<RangeSelectionProps, 'visibleMonths'>) => {
    const isWarpSM = useBreakpoints({ breakpoint: 'sm' });

    if (useRange) {
        return (
            <BasicDatePicker
                className={cn(styles.FrontpageDatePicker, className)}
                onDateChange={onDateChange}
                startDate={startDate}
                endDate={endDate}
                useRange={true}
                visibleMonths={2}
                modalFooter={modalFooter}
                upperDateLimit={upperDateLimit}
                disabledDateRanges={disabledDateRanges}
                useAnchor={
                    isWarpSM
                        ? {
                              title: useAnchor?.title || 'Når vil du reise?',
                              invalid: useAnchor?.invalid,
                              helpText: useAnchor?.helpText || null,
                          }
                        : undefined
                }>
                {children as [ReactElement<typeof TextField>, ReactElement<typeof TextField>]}
            </BasicDatePicker>
        );
    }

    return (
        <BasicDatePicker
            className={cn(styles.FrontpageDatePicker, className)}
            onDateChange={onDateChange}
            startDate={startDate}
            useRange={false}
            visibleMonths={2}
            modalFooter={modalFooter}
            upperDateLimit={upperDateLimit}
            disabledDateRanges={disabledDateRanges}
            useAnchor={
                isWarpSM
                    ? {
                          title: useAnchor?.title || 'Når vil du reise?',
                          invalid: useAnchor?.invalid,
                          helpText: useAnchor?.helpText || null,
                      }
                    : undefined
            }>
            {children as ReactElement<typeof TextField>}
        </BasicDatePicker>
    );
};
